import { PixelCrop } from 'react-image-crop';
import { canvasPreview } from './canvasPreview';

const previewUrl = '';

export async function imgPreview(
	image: HTMLImageElement,
	setCroppedImage: (src: string) => void,
	crop: PixelCrop,
	scale = 1,
	rotate = 0
) {
	const canvas = document.createElement('canvas');
	canvasPreview(image, canvas, crop, scale, rotate);
	const blob = canvas.toDataURL('image/jpeg');
	setCroppedImage(blob);
	return previewUrl;
}
